import { defineFeature } from '@/lib/platform/system';
import { scheduledBusesMachine } from '@/features/scheduled-buses/state/scheduled-buses.machine';

export const features = [
  defineFeature({
    id: 'scheduledBuses',
    machine: scheduledBusesMachine,
    emits: [],
    handles: [],
    accepts: [
      'scheduledBuses.chooseRoute',
      'scheduledBuses.chooseDirection',
      'scheduledBuses.chooseStop',
      'scheduledBuses.loadSchedule',
      'scheduledBuses.refresh',
    ],
  }),
] as const;
